import React, { useMemo } from "react";
import { graphql } from "gatsby";
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";
import slugify from "@sindresorhus/slugify";
import Breadcrumb from "./breadcrumb";
import sortPosition from "../utility/sort-position";

const ModuleIntro = ({ module, breadcrumb, className, isFirst }) => {
  const images = module.imageFieldSet.image
    ? module.imageFieldSet.image.nodeMobile
      ? withArtDirection(getImage(module.imageFieldSet.image.node), [
          {
            media: "(max-width: 800px)",
            image: getImage(module.imageFieldSet.image.nodeMobile),
          },
        ])
      : getImage(module.imageFieldSet.image.node)
    : null;
  const altImage =
    module.imageFieldSet && module.imageFieldSet.image ? module.imageFieldSet.altImage : "";
  return (
    <>
      {module?.anchorDesktop && (
        <span id={slugify(module.anchorDesktop)} className="tabs__scroll-anchor" />
      )}
      <div className={`intro${className ? ` ${className}` : ""}`}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 px-0">
              <div className="intro__wrapper text-center d-flex flex-column align-items-center">
                {breadcrumb && (
                  <Breadcrumb
                    className={`breadcrumb--absolute${images ? "" : " breadcrumb--dark"}`}
                    breadcrumb={breadcrumb}
                  />
                )}
                {images && (
                  <GatsbyImage
                    className="intro__image"
                    image={images}
                    alt={altImage}
                    loading="eager"
                  />
                )}
                {module.introTitle && (
                  <>
                    {isFirst ? (
                      <h1 className={`intro__title${images ? "" : " intro__title--dark"} mb-0`}>
                        {module.introTitle}
                      </h1>
                    ) : (
                      <h2 className={`intro__title${images ? "" : " intro__title--dark"} mb-0`}>
                        {module.introTitle}
                      </h2>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {module.titleSectionFieldSet &&
        module.titleSectionFieldSet.map((item, i) => (
          <section
            className={`section intro__section${
              item.colorSection && item.colorSection[0] === "Grey" ? " section--dark" : ""
            }`}
            key={i}
          >
            <div className="container">
              <div className="row" key={i}>
                <div className="col-12 text-center pb-lg-3">
                  {item.titleSection &&
                    (isFirst && module?.introTitle ? (
                      <h2>{item.titleSection}</h2>
                    ) : (
                      <h1>{item.titleSection}</h1>
                    ))}
                  {item.abstract && (
                    <div
                      className="intro__abstract mt-3 mb-3 mx-auto"
                      dangerouslySetInnerHTML={{ __html: item.abstract }}
                    ></div>
                  )}
                </div>
              </div>
            </div>
          </section>
        ))}
    </>
  );
};

const Intro = ({ data, breadcrumb, className, isFirst }) => {
  const modules = useMemo(
    () =>
      data.moduleTitleFieldSet.length
        ? data.moduleTitleFieldSet
            .filter(
              (item) =>
                item.introTitle ||
                item.imageFieldSet ||
                item.titleSectionFieldSet?.titleSection ||
                item.titleSectionFieldSet?.abstract
            )
            .sort(sortPosition)
        : data.moduleTitleFieldSet,
    [data.moduleTitleFieldSet]
  );
  return (
    <>
      {modules.map((module, i) => (
        <ModuleIntro
          module={module}
          className={className}
          breadcrumb={i === 0 ? breadcrumb : null}
          isFirst={isFirst}
          key={i}
        />
      ))}
    </>
  );
};

export default Intro;
export const fragment = graphql`
  fragment IntroFragment on LiferayIntro {
    id
    liferayFields {
      siteId
      articleId
    }
    moduleTitleFieldSet {
      anchorDesktop
      anchorMobile
      position
      introTitle: title
      imageFieldSet {
        image {
          node {
            gatsbyImageData(width: 1920, layout: CONSTRAINED)
          }
          nodeMobile: node {
            gatsbyImageData(height: 220, aspectRatio: 3.64, layout: CONSTRAINED)
          }
        }
        altImage
      }
      titleSectionFieldSet {
        titleSection
        abstract
        colorSection
      }
    }
  }
`;
